import { FC, useEffect } from "react";
import { useLocation } from "react-router";
import MainRoutes from "./common/components/router/MainRoutes";
import "./App.scss";

const App: FC = () => {
  const { pathname } = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return (
    <div>
      <MainRoutes />
    </div>
  );
};

export default App;
